import {actionTypes} from '../const';

const initialState = {
    notesObj:{},
    notes:[],
}

const notes = (state = initialState, action) => {
    switch (action.type) {       
        case actionTypes.GET_NOTES_SUCCESS:
            return Object.assign({}, state, {
                notes:action.notes
            });
        case actionTypes.SET_NOTES_SUCCESS:
            return Object.assign({}, state, {
                notesObj:action.notesObj
            });
        case actionTypes.HIDE_NOTES_SUCCESS:
            let notesState = state;
            notesState.notesObj.showNotesModal = false;
            return Object.assign({}, state, {
                notesObj:notesState
            });
        default:
            return state;
        }
}
export default notes